import type { IconDefinition } from '@ant-design/icons-angular';
import { NZ_ICONS_USED_BY_ZORRO } from 'ng-zorro-antd/icon';

export const icons: IconDefinition[] = [...NZ_ICONS_USED_BY_ZORRO];
